export default __webpack_public_path__ + "static/workflow-ingest-bd0cb7feaf0226fc27e1bfd503747db3.png";